import api from "../config/api";
import { StudentFeeReportParams } from "../redux/actions/studentFeeReport";


export const getStudentFeeReport = async (params: StudentFeeReportParams) => {
    return await api.get('/studentFee/', {
        params: {
            fromDate: params.fromDate,
            toDate: params.toDate
        }
    })
}